import { render } from "./BatteryReport.vue?vue&type=template&id=72532c28"
import script from "./BatteryReport.vue?vue&type=script&lang=js"
export * from "./BatteryReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__